module.exports = __webpack_public_path__ + "img/6.37bf8663.png";